import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-e-purse',
  templateUrl: './e-purse.component.html',
  styleUrls: ['./e-purse.component.css']
})
export class EPurseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
